import { Injectable } from '@angular/core';
import { DataCollectorService } from '../data_collector_services/data_collector_service.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { dataUrlMethod } from 'app/components/datagrid/datagrid.interface';

@Injectable({
    providedIn: 'root'
})
export class RequestService {
    get requestUrl(): any {
        return `${this.dataCollectorService.baseurl()}/request/`;
    }
    get requestGridUrls(): any {
        return {
            columnUrl: `${this.requestUrl}meta`,
            dataUrl: `${this.requestUrl}filter`,
            filterUrl: `${this.requestUrl}meta/filter`
        };
    }

    get requestAPIUrls(): any{
        return {
            dataUrl: `${this.requestUrl}filter`,
            columnUrl: `${this.requestUrl}meta`,
            filterUrl: `${this.requestUrl}meta/filter`,
            dataUrlMethod: dataUrlMethod.POST,
        };
    }

    get estimateUrl(): any {
        return `${this.dataCollectorService.baseurl()}/estimate`;
    } 
    get jobsUrl(): any {
        return `${this.dataCollectorService.baseurl()}/jobs`;
    } 
    get bulkActionUrl(): any {
        return `${this.requestUrl}bulk_action`;
    }
    get holidayUrl(): any {
        return `${this.dataCollectorService.baseurl()}/company/holidays`;
    }

    get requestSourceUrl(): any{
        return `${this.dataCollectorService.baseurl()}/request/source`;
    }
    get requestBaseUrl(): any {
        return `${this.dataCollectorService.baseurl()}/request`;
    }
    get requestServiceUrl(): any {
        return `${this.dataCollectorService.baseurl()}/request/services`;
    }
    get requestAssignUrl(): any {
        return this.requestUrl+ 'assign';
    }
    currentRequestDetails = new BehaviorSubject(null);

    constructor(private dataCollectorService: DataCollectorService) { }

    getRequestDetailsUrl(requestUid: string): string{
        return this.requestUrl + `${requestUid}`;
    }

    getMasterRequestStatus(): Observable<any> {
        const url =  this.requestUrl + 'status';
        return this.dataCollectorService.getData(url);
    }

    updateRequestStatus(requestStatusUpdate): Observable<any>{
        const requestStatusUrl = this.requestUrl+`${requestStatusUpdate.request_uid}/status`;
        const payload  = requestStatusUpdate.payload;
        return this.dataCollectorService.putData(requestStatusUrl,payload);
    }
    assignEmployeeToRequest(payload): Observable<any>{
        return this.dataCollectorService.postData(this.requestAssignUrl, payload);
    }

    getRequestStatusRollbackUrl(requestUid): string{
        return `${this.dataCollectorService.baseurl()}/request/${requestUid}/status/delete`;
    }

    deleteRequest(requestUID: string): any{
        return this.requestUrl + `${requestUID}`;
    }
    getRequestAttachmentUrl(requestUid: string): string {
        return this.requestUrl + `${requestUid}/attachments`;
    }

    updateRequest(requestUid: string, payload: any): Observable<any>{
        const url = this.requestUrl + requestUid;
        return this.dataCollectorService.putData(url, payload);
    }

    deleteURL(requestUid: string): any{
        return `${this.dataCollectorService.baseurl()}/request/${requestUid}/delete`;
    }

    requestDetailsUrl(requestUID: string): string{
        return `${this.dataCollectorService.baseurl()}/request/${requestUID}`;
    }
}
